import React, { useCallback, useEffect, useState } from 'react'
import classes from './style.module.scss'
import Affix from '../../../components/affix'
import { Iconfont } from "../../../components/icon/iconfont";

import { Swiper, SwiperSlide } from 'swiper/react'
import PageFilter from '../components/filter'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'


import useStyles from 'isomorphic-style-loader/useStyles'
import { useApp, useQuery } from '../../../hooks/common';
import BottomTools from './bottom-tools'
import { GiftsTools } from './gifts';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { IMAGE_GEEKO_LTD } from '../../../../constants'
import { SET_SEARCH_IMAGE_RESULT } from '../../../../store/actions/global';
import OutsideFilter from '../components/filter/outside-filter'


const PageSorter = props => {
	useStyles(classes)
	const { sorters, sorter } = props
	const [values, setValues] = useState([])

	useEffect(() => {
		if (sorters instanceof Array) {
			setValues(sorters)
		} else {
			const arr = []
			Object.keys(sorters).map(key => {
				arr.push({ label: sorters[key], value: key })
			})
			setValues(arr)
		}
	}, [sorters])



	return <React.Fragment>
		<div className={classes.PageSorter}>
			{
				values.map((v, index) => <div onClick={() => { props.onSorter(index) }} className={`${classes.Sorter} ${sorter === index ? classes.Selected : ''}`} key={v.value}>{v.label}</div>)
			}
		</div>
	</React.Fragment>
}


export const Breadcrumb = props => {
	useStyles(classes)
	const { links, total } = props

	const query = useQuery();

	return <div className={classes.Breadcrumb}>
		<a href={'/'}>
			<FormattedMessage id="home" defaultMessage="Home" />
		</a>

		{
			query?.searchTitle ? <React.Fragment>
				<h1>
					<span>{query.searchTitle}</span>
					{
						total && <span className={classes.Total}>
							(<FormattedMessage id="count_items" values={{ total }} defaultMessage="{total} Items" />)
						</span>
					}

				</h1>
			</React.Fragment> : <React.Fragment>
				{
					links?.map((link, index) => (!link.href || link.href === '#') ? <h1 key={index}>
						<span>{link.title}</span>
						{
							!!total && <span className={classes.Total}>
								(<FormattedMessage id="count_items" values={{ total }} defaultMessage="{total} Items" />)
							</span>
						}

					</h1> : <a key={index} href={link.href}>{link.title}</a>)
				}
			</React.Fragment>
		}
	</div>
}

export const SortFilter = props => {

	useStyles(classes)

	const dispatch = useDispatch()
	const ui = useSelector((state) => state.ui)

	const { filterVo, sorters, offsetTop } = props
	const [showFilter, setShowFilter] = useState(false)
	const [showSorter, setShowSorter] = useState(false)
	const [showOutSideFilter, setShowOutSideFilter] = useState(false)
	const [currentFilterItem, setCurrentFilterItem] = useState(null)
	const [filterValue, setFilterValue] = useState(props.value || [])
	const [selectedTags, setSelectedTags] = useState(props.tag?.selections)
	const [fixed, setFixed] = useState(false)
	const isApp = useApp()
	const [swiper, setSwiper] = useState(null)

	const tags = filterVo?.filterItems?.find(f => f.fieldName === 'tags')?.selections
	const submitHandle = value => {
		setFilterValue(value)
		props?.onSubmit(value)
		setShowFilter(false)

		if (window.GeekoSensors) {
			window.GeekoSensors.Track('Filter', {
				'filter': (value || []).map(item => {
					const fieldName = item.fieldName
					const selectionStr = (item.selections || []).map(s => s.value).join(',')
					return `${fieldName}:${selectionStr}`
				}).join(';'),
			})
		}

	}

	const clearHandle = () => {
		setFilterValue([])
		if (window.GeekoSensors) {
			window.GeekoSensors.Track("ELClick", {
				clicks: 'Clear'
			})
		}
	}

	const sorterHandle = sorter => {
		props.onSorter(sorter)
		setShowSorter(false)
		if (window.GeekoSensors) {
			window.GeekoSensors.Track("Sorter", {
				sort: sorter
			})
		}
	}

	const tagHandle = tag => {

		if (isActiveTag(tag)) {
			setSelectedTags([])
			props?.onTag()
		} else {
			setSelectedTags([tag])
			props?.onTag(tag)

			if (window.GeekoSensors) {
				window.GeekoSensors.Track("Tag", {
					tag: tag?.value
				})
			}
		}


	}

	const isActiveTag = tag => {
		return selectedTags?.some(s => s.value === tag.value)
	}


	const filterClickHandle = () => {
		setShowOutSideFilter(false)
		if (filterVo && filterVo.filterItems && filterVo.filterItems.length > 0) {
			setShowFilter(true)
		}
		if (window.GeekoSensors) {
			window.GeekoSensors.Track("ELClick", {
				clicks: 'filter'
			})
		}
	}

	const outsideFilterClickHandle = (fitlerItem) => {
		setShowSorter(false)
		if(!showOutSideFilter){
			
			setShowOutSideFilter(true)
			setCurrentFilterItem(fitlerItem)
			if (window.GeekoSensors) {
				window.GeekoSensors.Track("ELClick", {
					clicks: 'outside-filter',
					content: fitlerItem.fieldName
				})
			}
		}else{
			setShowOutSideFilter(false)
		}
	}

	const searchOffSet = props.searchOffSet || 0


	const useOldTags = tags?.some(tag => !!!tag.imageURL)


	const callBackHandle = useCallback(f => {
		setFixed(f)
		setTimeout(() => {
			swiper?.update()
		}, 300)
	}, [swiper])

	return <React.Fragment>

		<Affix offsetTop={isApp ? (0 + searchOffSet) : (44 + searchOffSet)} callBack={callBackHandle}>

			{
				tags && tags.length > 0 && !useOldTags && <div className={classes.ImageTagContainer}>
					<Swiper
						onSlideChange={() => { }}
						onSwiper={setSwiper}
						spaceBetween={7}
						slidesPerView={'auto'}
					>
						{
							tags?.map((tag, index) => <SwiperSlide key={`${index}-${tag.value}`} style={{ width: 'auto' }}>
								<div onClick={() => { tagHandle(tag) }} className={`${classes.ImageTag} ${fixed ? classes.Fixed : ''} ${isActiveTag(tag) ? classes.Active : ''}`}>
									<div className={`${classes.Image}`}>
										<LazyLoadImage src={`${IMAGE_GEEKO_LTD}${tag.imageURL}`} />
									</div>
									<div className={classes.Text}>
										<span className={classes.TextBox}>
											{tag.label}
										</span>
									</div>
								</div>
							</SwiperSlide>)
						}
					</Swiper>
				</div>
			}


			<div className={classes.SortFilter}>

				{/* {
					!isApp && <div className={classes.Search} onClick={() => {
						dispatch({
							type: SET_SEARCH_IMAGE_RESULT,
							payload: {
								show: true,
								searchType: 0
							}
						})

						if (window.GeekoSensors) {
							window.GeekoSensors.Track("click_search")
						}
					}}>
						<Iconfont className={classes.SearchIcon}>&#xe772;</Iconfont>
						<span className={classes.SearchLabel}>
							<FormattedMessage id="search" defaultMessage="Search" />
						</span>
						<Iconfont className={classes.CanmeraIcon}>&#xe706;</Iconfont>
					</div>
				} */}




				<div>
					<span className={classes.FilterClick} onClick={() => {
						setShowSorter(!showSorter)
						setShowOutSideFilter(false)
						if (window.GeekoSensors) {
							window.GeekoSensors.Track("ELClick", {
								clicks: 'sort'
							})
						}
					}
					}>
						<span style={{ wordBreak: 'break-all' }}>
							<FormattedMessage id="sort" defaultMessage="Sort" />
						</span>
						<Iconfont style={{ fontSize: 12 }}>&#xe671;</Iconfont>
					</span>
				</div>



				{
					filterVo?.filterItems?.filter(f => f.fieldName !== 'tags')?.map((filterItem, index) => index <= 1 && <span className={classes.FilterClick} onClick={() => outsideFilterClickHandle(filterItem)}>
						<span style={{ wordBreak: 'break-all' }}>
							{filterItem.title}
						</span>
						<Iconfont style={{ fontSize: 12 }}>&#xe671;</Iconfont>
					</span>)
				}


				<div style={{ cursor: 'pointer', width: isApp ? '50%' : undefined }} onClick={filterClickHandle}>
					<span className={classes.FilterClick} style={{ borderLeft: '1px solid #efefef' }}>
						<FormattedMessage id="filter" defaultMessage="Filter" />
					</span>
				</div>
			</div>

			{
				showOutSideFilter && <div style={{ position: 'relative', zIndex: 2 }}>
					<OutsideFilter value={props.value} onSubmit={submitHandle} filterItem={currentFilterItem}  onClose={() => { setShowOutSideFilter(false) }} />
				</div>
			}

			{
				showSorter && <div style={{ position: 'relative', zIndex: 2 }}>
					<PageSorter sorters={props.sorters} onSorter={sorterHandle} sorter={props.sorter} />
				</div>
			}

		</Affix>


		{
			tags && tags.length > 0 && useOldTags && <div className={classes.TagContainer}>
				<Swiper
					onSlideChange={() => { }}
					onSwiper={(swiper) => { }}
					spaceBetween={10}
					slidesPerView={'auto'}
				>
					{
						tags?.map((tag, index) => <SwiperSlide className={`${classes.Tag} ${isActiveTag(tag) ? classes.Active : ''}`} key={tag.value}>
							<span onClick={() => { tagHandle(tag) }}>{tag.label}</span>
						</SwiperSlide>)
					}
				</Swiper>
			</div>
		}

		{
			<PageFilter value={props.value} onClear={clearHandle} onSubmit={submitHandle} filterVo={filterVo} showFilter={showFilter} onClose={() => { setShowFilter(false) }} />
		}

	</React.Fragment>
}

export default props => {
	const { showBottomTools, showGiftsTools } = props
	const isApp = useApp()
	return <div className={classes.PageContainer}>

		{
			!isApp && <Breadcrumb links={props.links} total={props.total} />
		}



		{
			showGiftsTools && <GiftsTools />
		}
		<div>
			{props.extra && props?.extra()}
		</div>

		<SortFilter {...props} />
		<div>
			{props.children}
		</div>

		{
			showBottomTools && <BottomTools />
		}
	</div>
}